import { headerStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryHeader";
import SlidersHorizontal from "@waytek/MobiusOverrides/Icons/SlidersHorizontal";
import { colorPalette, fontFamily, mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

headerStyles.heading = {
    ...headerStyles.heading,

    weight: 500,
    lineHeight: "normal",

    css: css`
        font-size: 26px;
        display: none; 

        ${mediaQueriesBP.minMD} {
            font-size: 36px;
            margin-bottom: 32px;
        }
    `,
};

headerStyles.toggleFilterButton = {
    ...headerStyles.toggleFilterButton,
    buttonType: "outline",
    css: css`
        ${headerStyles.toggleFilterButton?.css}

        &&&:hover {
            &::after {
                content: none;
            }
        }
    `,
};

headerStyles.toggleFilterButtonIcon = {
    ...headerStyles.toggleFilterButtonIcon,
    color: colorPalette.common.global.guardianBlue,
    src: SlidersHorizontal,
};

headerStyles.invoiceCountGridItem = {
    ...headerStyles.invoiceCountGridItem,

    css: css`
        font-family: ${fontFamily};
        font-size: 18px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.33;
        color: #363636;
    `,
};
